import { request } from "../libs";

function fetchZegebaContacts() {
	return request(
		"/server/contacts",
		{ method: "GET" }
	)
		.then(res => res.json());
}

export default fetchZegebaContacts;



// WEBPACK FOOTER //
// ./src/api/fetch-zegeba-contacts.js